export enum OrderStatus {
  IDLE = "idle",
  PROCESSING = "processing",
  CANCELLED = "cancelled",
}
